module.exports = __webpack_public_path__ + "static/store-owner-48809e39d8f61a0d17925ba71baf377b.jpg";